<template>
  <v-card>
    <v-card-text>
      <v-row no-dense>
        <v-col cols="4">
          <v-autocomplete
            v-model="selectedSettings"
            :items="settingsFilters"
            label="Settings"
            chips
            small-chips
            dense
            filled
            multiple
            hide-details
          />
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            v-model="selectedEvents"
            :items="eventsFilters"
            label="Events"
            chips
            small-chips
            dense
            filled
            multiple
            hide-details
          />
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            v-model="selectedUsers"
            :items="userFilters"
            label="Users"
            chips
            small-chips
            dense
            filled
            multiple
            hide-details
          />
        </v-col>
      </v-row>
      <div>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </div>
    </v-card-text>
    <v-data-table
      :headers="headers"
      :items="filteredData"
      :search="search"
      :loading="loading"
      :items-per-page="50"
      :sort-by="['name', 'PlayerNickname', 'playtime']"
      :sort-desc="[false, false, false]"
      :footer-props="{
        'items-per-page-options': [50, 100, 250, -1]
      }"
      multi-sort
    >
      <template v-slot:item.PlayerNickname="{ item }">
        <div>
          User: {{ item.PlayerNickname }}
        </div>
        <div>
          UserID: {{ item.UserID }}
        </div>
      </template>
      <template v-slot:item.playtime="{ item }">
        {{ timeToString(item.playtime) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiMagnify } from '@mdi/js'
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      mdiMagnify,
      search: '',
      loading: false,
      table: [],
      headers: [
        {
          text: 'Setting name',
          align: 'left',
          filterable: false,
          value: 'name',
          width: 200
        },
        {
          text: 'Value',
          align: 'left',
          value: 'value',
          width: 100
        },
        {
          text: 'Player',
          align: 'left',
          value: 'PlayerNickname',
          width: 230
        },
        {
          text: 'Session id',
          align: 'left',
          value: 'session_id',
          width: 150
        },
        {
          text: 'Event name',
          align: 'left',
          value: 'event_name',
          width: 150
        },
        {
          text: 'Playtime',
          align: 'left',
          value: 'playtime',
          width: 150
        }
      ],
      selectedSettings: [],
      selectedEvents: [],
      selectedUsers: []
    }
  },
  async mounted () {
    await this.getStatistic()
  },
  watch: {
    async '$route.query' () {
      await this.getStatistic()
    }
  },
  computed: {
    filteredData () {
      return this.table.filter(val => {
        let flag = true

        if (this.selectedSettings.length) {
          flag = flag && this.selectedSettings.includes(val.name)
        }

        if (this.selectedEvents.length) {
          flag = flag && this.selectedEvents.includes(val.event_name)
        }

        if (this.selectedUsers.length) {
          flag = flag && this.selectedUsers.includes(val.PlayerNickname)
        }

        return flag
      })
    },
    settingsFilters () {
      return this.table.reduce((settings, val) => {
        if (settings.includes(val.name)) return settings
        return [...settings, val.name]
      }, [])
    },
    eventsFilters () {
      return this.table.reduce((events, val) => {
        if (events.includes(val.event_name)) return events
        return [...events, val.event_name]
      }, [])
    },
    userFilters () {
      return this.table.reduce((users, val) => {
        if (users.includes(val.PlayerNickname)) return users
        return [...users, val.PlayerNickname]
      }, [])
    }
  },
  methods: {
    async getStatistic () {
      if (!this.$route.query.build_id) {
        return
      }

      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/config-settings/table`, {
          params: {
            build_id: this.$route.query.build_id
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.table = data
      }
      this.loading = false
    }
  }
}
</script>